"use strict";
import { Token } from "@uniswap/sdk-core";
import { useMemo } from "react";
import { isAddress } from "utilities/src/addresses";
import { assume0xAddress } from "utils/wagmi";
import { erc20Abi } from "viem";
import { useReadContracts } from "wagmi";
export function useOnchainTokenMetadata(address, chainId, skip) {
  const onchainAddress = useMemo(() => address ? isAddress(address) : false, [address]);
  const contracts = useMemo(() => {
    if (!onchainAddress || !chainId) {
      return void 0;
    }
    const tokenAddress = assume0xAddress(onchainAddress);
    return [
      { address: tokenAddress, abi: erc20Abi, functionName: "symbol", chainId },
      { address: tokenAddress, abi: erc20Abi, functionName: "name", chainId },
      { address: tokenAddress, abi: erc20Abi, functionName: "decimals", chainId }
    ];
  }, [chainId, onchainAddress]);
  const metadataQuery = useReadContracts({
    contracts,
    query: {
      enabled: Boolean(onchainAddress && chainId && !skip)
    }
  });
  const token = useMemo(() => {
    if (!onchainAddress || !chainId) {
      return void 0;
    }
    const symbol = metadataQuery.data?.[0]?.result;
    const name = metadataQuery.data?.[1]?.result;
    const decimals = metadataQuery.data?.[2]?.result;
    if (typeof symbol !== "string" || typeof decimals !== "number") {
      return void 0;
    }
    return new Token(chainId, onchainAddress, decimals, symbol, typeof name === "string" ? name : symbol);
  }, [chainId, metadataQuery.data, onchainAddress]);
  const hasContractFailure = metadataQuery.data?.some((result) => result.status === "failure") ?? false;
  return {
    token,
    isLoading: metadataQuery.isLoading,
    isFetching: metadataQuery.isFetching,
    isError: metadataQuery.isError || hasContractFailure,
    refetch: metadataQuery.refetch
  };
}
